"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegEx = exports.getINTLCompatibleLocale = exports.validateLocale = exports.sanitizeLocale = void 0;
const GetOverrideLocale_1 = require("./getOverrideLocale/GetOverrideLocale");
const sanitizeLocale = (locale) => {
    const newLocale = (0, GetOverrideLocale_1.getOverrideLocale)(locale);
    switch (locale) {
        case "en-CA":
        case "pseudo":
            return "en-US";
        case "en-international":
            return "en-GB";
        case "es":
            return "es-419";
        case "fr-CA":
            return "fr-FR";
        default:
            return newLocale === "en" ? "en-US" : newLocale;
    }
};
exports.sanitizeLocale = sanitizeLocale;
function validateLocale(locale) {
    try {
        new Intl.NumberFormat(locale);
        return locale;
    }
    catch (_a) {
        const warnMessage = `@procore/globalization-toolkit: ${locale} is not supported by Intl.NumberFormat.`;
        console.warn(warnMessage);
        throw new Error(warnMessage);
    }
}
exports.validateLocale = validateLocale;
function getINTLCompatibleLocale(locale) {
    try {
        return validateLocale(locale);
    }
    catch (_a) {
        return (0, exports.sanitizeLocale)(locale);
    }
}
exports.getINTLCompatibleLocale = getINTLCompatibleLocale;
function escapeRegEx(value) {
    return value.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
exports.escapeRegEx = escapeRegEx;
//# sourceMappingURL=FormatterUtils.js.map